// extracted by mini-css-extract-plugin
export default {"productPage":"styles_productPage__tEsZY"};